<template>
  <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="10" transition="scale-transition" lazy offset-y
          full-width min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field v-model="actualDatetime" :mask="mask" :disabled="disabled" :label="label" readonly
                    append-icon="event" class="mt-1" hide-details v-on="on"
      />
    </template>
    <v-tabs ref="tabs" v-model="selectedTab" grow icons>
      <v-tab key="calendar">
        <v-icon>event</v-icon>
      </v-tab>
      <v-tab v-if="timeFormat" key="time">
        <v-icon>access_time</v-icon>{{ $props.props }}
      </v-tab>
      <v-tab-item key="calendar">
        <v-date-picker v-model="dateModel" :readonly="disabled" first-day-of-week="1" locale="es" no-title scrollable
                       @input="toTime"
        />
      </v-tab-item>
      <v-tab-item v-if="timeFormat" key="time">
        <v-time-picker ref="time" v-model="timeModel" :readonly="disabled" no-title scrollable format="24hr"
                       @input="checkTime"
        />
      </v-tab-item>
    </v-tabs>
  </v-menu>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DateTime',
  props: {
    value: { type: [Date, String, Number, Object], default: '' },
    mask: { type: String, default: '##/##/#### ##:##:##' },
    datePickerFormat: { type: String, default: 'YYYY-MM-DD' },
    dateFormat: { type: String, default: 'DD/MM/YYYY' },
    timeFormat: { type: String, default: 'HH:mm:ss' },
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data () {
    return {
      dateModel: '',
      timeModel: '',
      menu: false,
      selectedTab: 0,
      date: null,
      dateFormatted: null,
      timer: null
    }
  },
  computed: {
    actualDatetime: {
      get: function () {
        return !this.value ? '' : moment(this.dateModel + ' ' + this.timeModel, `${this.datePickerFormat} ${this.timeFormat}`).format(`${this.dateFormat} ${this.timeFormat}`)
      },
      set: function (val) { }
    }
  },
  watch: {
    value (value) {
      if (value) {
        let newDate = Date.now()
        if (Number.isInteger(value) || (typeof value === 'string' && value.includes('T')) ||
         (!typeof value === 'string' && value.isValid())) {
          newDate = moment(value)
        } else newDate = moment(value, `${this.dateFormat} ${this.timeFormat}`)

        if (!newDate.isValid()) newDate = moment(value, 'YYYY-MM-DD HH:mm:ss')
        this.dateModel = newDate.format(this.datePickerFormat)
        this.timeModel = newDate.format(this.timeFormat) === '00:00:00' ? moment().format(this.timeFormat) : newDate.format(this.timeFormat)
      }
    },
    menu (val) {
      if (val) {
        this.selectedTab = 0
        if (this.$refs.time) { this.$refs.time.selectingHour = true }
      }
    }
  },
  created () {
    if (this.value) {
      var dateTime = moment(this.value)
      this.dateModel = moment(dateTime).format(this.datePickerFormat)
      this.timeModel = moment(dateTime).format(this.timeFormat)
    }
  },
  methods: {
    checkTime (val) {
      if (this.timer) clearTimeout(this.timer)
      if (this.$refs.time.selectingHour === false) {
        this.timeModel = val
        this.timer = setTimeout(() => {
          this.$refs.time.selectingHour = true
          this.selectedTab = 0
          this.menu = false
          this.$emit('input', moment(this.actualDatetime, `${this.dateFormat} ${this.timeFormat}`))
        }, 1000)
      } else {
        this.timer = setTimeout(() => {
          this.$refs.time.selectingHour = false
        }, 1000)
      }
    },
    toTime (val) {
      this.dateModel = val
      this.selectedTab = 1
      this.$emit('input', moment(this.actualDatetime, `${this.dateFormat} ${this.timeFormat}`))
    }
  }
}
</script>
